import { useQuery } from "@apollo/client";
import { List } from "antd";
import { GET_ONCOLOGISTS } from "./oncologists.qql";
import DoctorItem from "./doctorItem";
import classes from "./doctors.module.css";

const Doctors = () => {
  const { data, loading, error } = useQuery(
    GET_ONCOLOGISTS,
    {
      fetchPolicy: "no-cache",
    }
  );

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <div className={classes.root}>
      <List
        pagination={{ size: "small", pageSize: 8, position: "bottom", align: "center" }}
        grid={{ gutter: 16, column: 2, xs: 1, sm: 1, md: 1, lg: 2 }}
        dataSource={data.oncologists}
        renderItem={(doctor: any) => (
          <List.Item key={doctor.id}>
            <DoctorItem doctor={doctor} />
          </List.Item>
        )}
      />
    </div>
  );
};

export default Doctors;
